(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accelerated-checkout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('direct-checkout-button')) {
    customElements.define(
      'direct-checkout-button',
      class DirectCheckoutButton extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          this.form = this.closest('form');
          this.button?.addEventListener('click', () => this.checkout());
        }

        async checkout() {
          if (!this.form || !this.button || this.button.disabled) return;

          const label = this.querySelector('.direct-checkout__label');
          const loading = this.querySelector('.direct-checkout__loading');
          const error = this.querySelector('.direct-checkout__error');

          this.button.disabled = true;
          label.hidden = true;
          loading.hidden = false;
          error.hidden = true;

          try {
            const response = await fetch(this.dataset.cartAddUrl, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new FormData(this.form),
            });

            if (!response.ok) throw new Error('cart-add-failed');
            window.location.assign(this.dataset.checkoutUrl);
          } catch (checkoutError) {
            this.button.disabled = false;
            label.hidden = false;
            loading.hidden = true;
            error.hidden = false;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_article-interactive"] && !Shopify.designMode) return;
  try {
    (() => {
    const slugify = (value) => value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');

    document.querySelectorAll('[data-lj-article-guide]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const scope = root.closest('.article-content');
      if (!scope) return;

      const headings = [...scope.querySelectorAll('h2')]
        .filter((heading) => !root.contains(heading) && heading.textContent.trim())
        .slice(0, 10);

      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `guide-${index + 1}-${slugify(heading.textContent)}`;
      });

      const toc = root.querySelector('[data-lj-toc]');
      headings.forEach((heading) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        toc.append(item);
      });

      const practicalHeadings = headings.filter((heading) => /^étape\s+\d+/i.test(heading.textContent.trim()));
      const steps = (practicalHeadings.length >= 3 ? practicalHeadings : headings
        .filter((heading) => !/questions fréquentes|faq/i.test(heading.textContent)))
        .slice(0, 4);
      const checklist = root.querySelector('[data-lj-checklist]');
      const count = root.querySelector('[data-lj-count]');
      const status = root.querySelector('[data-lj-status]');
      const progress = root.querySelector('[data-lj-check-progress]');
      const progressBar = progress.querySelector('span');
      const storageKey = root.dataset.storageKey;
      let saved = [];

      try {
        saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
      } catch (_) {
        saved = [];
      }

      const update = () => {
        const inputs = [...checklist.querySelectorAll('input')];
        const completed = inputs.filter((input) => input.checked).length;
        const percentage = inputs.length ? Math.round((completed / inputs.length) * 100) : 0;
        count.textContent = `${completed} / ${inputs.length}`;
        progress.setAttribute('aria-valuenow', String(percentage));
        progressBar.style.width = `${percentage}%`;
        status.textContent = completed === inputs.length && inputs.length
          ? root.dataset.completeLabel
          : root.dataset.remainingLabel.replace('__COUNT__', String(inputs.length - completed));
        try {
          localStorage.setItem(storageKey, JSON.stringify(inputs.filter((input) => input.checked).map((input) => input.value)));
        } catch (_) {}
      };

      steps.forEach((heading, index) => {
        const item = document.createElement('li');
        const label = document.createElement('label');
        const input = document.createElement('input');
        const text = document.createElement('span');
        input.type = 'checkbox';
        input.value = heading.id;
        input.id = `${storageKey}-${index}`;
        input.checked = saved.includes(heading.id);
        text.textContent = heading.textContent.trim();
        label.htmlFor = input.id;
        label.append(input, text);
        item.append(label);
        checklist.append(item);
        input.addEventListener('change', update);
      });

      update();

      scope.querySelectorAll('[data-lj-routine-builder]').forEach((builder) => {
        if (builder.dataset.ready === 'true') return;
        builder.dataset.ready = 'true';
        const buttons = [...builder.querySelectorAll('[data-lj-builder-choice]')];
        const results = [...builder.querySelectorAll('[data-lj-builder-result]')];
        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            const reveal = () => {
              buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
              results.forEach((result) => {
                result.hidden = result.dataset.ljBuilderResult !== button.dataset.ljBuilderChoice;
              });
            };
            if (document.startViewTransition) document.startViewTransition(reveal);
            else reveal();
          });
        });
      });

      scope.querySelectorAll('[data-lj-inline-checklist]').forEach((list) => {
        if (list.dataset.ready === 'true') return;
        list.dataset.ready = 'true';
        const inputs = [...list.querySelectorAll('input[type="checkbox"]')];
        const countOutput = list.querySelector('[data-lj-inline-count]');
        const statusOutput = list.querySelector('[data-lj-inline-status]');
        const progressOutput = list.querySelector('[data-lj-inline-progress]');
        const progressBar = progressOutput.querySelector('span');
        const key = list.dataset.storageKey;
        let checkedValues = [];
        try {
          checkedValues = JSON.parse(localStorage.getItem(key) || '[]');
        } catch (_) {
          checkedValues = [];
        }
        inputs.forEach((input) => {
          input.checked = checkedValues.includes(input.value);
        });
        const refresh = () => {
          const done = inputs.filter((input) => input.checked).length;
          const percentage = inputs.length ? Math.round((done / inputs.length) * 100) : 0;
          countOutput.textContent = `${done} / ${inputs.length}`;
          progressOutput.setAttribute('aria-valuenow', String(percentage));
          progressBar.style.width = `${percentage}%`;
          statusOutput.textContent = list.dataset.statusTemplate
            .replace('__DONE__', String(done))
            .replace('__TOTAL__', String(inputs.length));
          try {
            localStorage.setItem(key, JSON.stringify(inputs.filter((input) => input.checked).map((input) => input.value)));
          } catch (_) {}
        };
        inputs.forEach((input) => input.addEventListener('change', refresh));
        refresh();
      });

      scope.querySelectorAll('[data-lj-quiz]').forEach((quiz) => {
        if (quiz.dataset.ready === 'true') return;
        quiz.dataset.ready = 'true';
        quiz.querySelectorAll('[data-lj-quiz-question]').forEach((question) => {
          const buttons = [...question.querySelectorAll('[data-lj-quiz-answer]')];
          const feedback = question.querySelector('[data-lj-quiz-feedback]');
          buttons.forEach((button) => {
            button.addEventListener('click', () => {
              buttons.forEach((item) => {
                item.classList.remove('is-correct', 'is-wrong');
                item.setAttribute('aria-pressed', 'false');
              });
              button.setAttribute('aria-pressed', 'true');
              button.classList.add(button.dataset.correct === 'true' ? 'is-correct' : 'is-wrong');
              feedback.textContent = button.dataset.feedback;
            });
          });
        });
      });

      const readingBar = root.querySelector('[data-lj-reading-bar]');
      const updateReadingProgress = () => {
        const rect = scope.getBoundingClientRect();
        const total = Math.max(scope.scrollHeight - window.innerHeight, 1);
        const passed = Math.min(Math.max(-rect.top, 0), total);
        root.style.setProperty('--lj-reading-progress', `${Math.round((passed / total) * 100)}%`);
      };
      updateReadingProgress();
      document.addEventListener('scroll', updateReadingProgress, { passive: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
